import pkg from '../../package.json';
const { version } = pkg;

const env = process.env.HOST_ENV || 'development';

let sentryLoadState = {
  isLoaded: false,
  isLoading: false,
  loadPromise: null,
};

export function loadSentryScript() {
  if (sentryLoadState.isLoaded) {
    return Promise.resolve();
  }

  if (sentryLoadState.isLoading) {
    return sentryLoadState.loadPromise;
  }

  sentryLoadState.isLoading = true;

  sentryLoadState.loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://browser.sentry-cdn.com/7.23.0/bundle.tracing.min.js';
    script.crossOrigin = 'anonymous';
    script.defer = true;

    script.onload = () => {
      if (typeof Sentry !== 'undefined') {
        sentryLoadState.isLoaded = true;
        sentryLoadState.isLoading = false;
        resolve();
      } else {
        reject(new Error('Failed to load Sentry SDK'));
      }
    };

    script.onerror = () => {
      sentryLoadState.isLoading = false;
      reject(new Error('Error loading Sentry SDK'));
    };

    document.head.appendChild(script);
  });

  return sentryLoadState.loadPromise;
}

export function updateSentryForMFE({
  dsn = 'https://c86fb8ed103843429bb2cc02cc953e6b@sentry-api.paytm.com/497', //keep FSM dsn as default
  tags = {},
  release,
  environment,
  enabled,
  ...otherConfigs
}) {
  loadSentryScript()
    .then(() => {
      if (typeof window.Sentry !== 'undefined') {
        window.Sentry.init({
          dsn,
          integrations: [new window.Sentry.Integrations.BrowserTracing()],
          tracesSampleRate: 1.0,
          environment: environment || env,
          release: release || `${version}_${env}`,
          normalizeDepth: 10,
          enabled: enabled !== 'development',
          ...otherConfigs,
          // ... other global configurations
        });

        window.Sentry.configureScope((scope) => {
          for (const [key, value] of Object.entries(tags)) {
            scope.setTag(key, value);
          }
        });
      } else {
        console.error('Sentry is not initialized in mfe');
      }
    })
    .catch((error) => {
      console.error(error.message);
    });
}
